import * as actions from './constants';

const initialState = {
  cities: [],
  states: []
};

// eslint-disable-next-line default-param-last
export default function geoReducer(state = initialState, action) {
  switch (action.type) {
    case actions.ADD_GEO_DATA:
      return {
        ...state,
        cities: action.payload.cities,
        states: action.payload.states
      };
    // case actions.RESET_STATE:
    //   return {
    //     cities: [],
    //     states: []
    //   };
    default:
      return state;
  }
}
